import type { ContentfulPageBreadcrumbFragment } from '@/graphql/contentful/api';
import { sortBreadcrumb } from '@/integrations/contentful';
import { url } from '@/lib/paths';

import type { BreadcrumbItem } from './Breadcrumb';

export const buildBreadcrumbFromContentful = (
  list: ContentfulPageBreadcrumbFragment[],
): BreadcrumbItem[] => {
  const sortList = sortBreadcrumb(list);

  return sortList.map((item) => {
    const slug = item.slug === '/' ? '/' : `/${item.slug}`;
    return {
      label: item.pageTitle,
      target: url(slug).url(),
    } as BreadcrumbItem;
  });
};
